import React, { useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import './ContactForm.css'; // Updated styles
import axios from 'axios';
import { Alert, Snackbar } from '@mui/material';

function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        message: ''
    });
    const [errors, setErrors] = useState({});
    const [loader, setLoader] = useState(false);

    const validateForm = () => {
        let formIsValid = true;
        let errors = {};

        if (!formData.name) {
            formIsValid = false;
            errors['name'] = 'Name is required';
        }

        if (!formData.phone) {
            formIsValid = false;
            errors['phone'] = 'Phone number is required';
        }

        if (!formData.email) {
            formIsValid = false;
            errors['email'] = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            formIsValid = false;
            errors['email'] = 'Email is invalid';
        }

        if (!formData.message) {
            formIsValid = false;
            errors['message'] = 'Please enter your query';
        }

        setErrors(errors);
        return formIsValid;
    }

    const [open, setOpen] = React.useState({open: false, msg: ''});

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
        return;
        }

        setOpen(false);
    };
    
    const handleSubmit = async(event) => {
        event.preventDefault();
        if (validateForm()) {
            setLoader(true)
            console.log('Form data submitted:', formData.email);
            console.log('Form data submitted:', formData.message);
            console.log('Form data submitted:', formData.name);
            console.log('Form data submitted:', formData.phone);
            console.log('Form data submitted:', formData);
            // Here you can also integrate API calls to submit the form data.

            try {
                const response = await axios.post(
                  'https://api.walletly.ai/api/v4/transaction/sendEmail',
                  {
                    // From: formData.email,
                    From: 'business@walletly.ai',
                    ReplyTo: formData.email,
                    To: 'hello@walletly.ai',
                    TemplateId: '37839093',
                    TemplateModel: {
                        name: formData.name,
                        email: formData.email,
                        phone: formData.phone,
                        msg: formData.message,
                    }
                  }
                );
                setOpen({open: true, msg: 'Email sent successfully'})
                console.log('Email sent successfully:', response.data);
                setFormData({
                    name: '',
                    phone: '',
                    email: '',
                    message: ''
                })
            } catch (error) {
                setOpen({open: true, msg: 'Error sending email'})
                console.error('Error sending email:', error.response?.data || error.message);
                setFormData({
                    name: '',
                    phone: '',
                    email: '',
                    message: ''
                })
            }
            setLoader(false)
        }
    }

    const handleChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value
        });
    }

    return (
        <div className="contact-form">
            <div className='nestedform'><img loading="lazy" src='https://imagedelivery.net/xom6JLKEu4N3wOOpuxFt7Q/1dbc334f-23b8-42c8-fe9a-7d8f65dffe00/walletly' /></div>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Name:</label>
                    <input type="text" name="name" value={formData.name} onChange={handleChange} />
                    {errors.name && <div className="error">{errors.name}</div>}
                </div>
                <div className='d-flex gap-24 w-100 column'>
                    <div className="form-group w-100">
                        <label>Phone:</label>
                        <PhoneInput
                            international
                            defaultCountry="US"
                            value={formData.phone}
                            onChange={phone => setFormData({ ...formData, phone })}
                        />
                        {errors.phone && <div className="error">{errors.phone}</div>}
                    </div>
                    <div className="form-group w-100">
                        <label>Email:</label>
                        <input type="email" name="email" value={formData.email} onChange={handleChange} />
                        {errors.email && <div className="error">{errors.email}</div>}
                    </div>
                </div>
                <div className="form-group">
                    <label>How can we help you?</label>
                    <textarea rows={5} name="message" value={formData.message} onChange={handleChange}></textarea>
                    {errors.message && <div className="error">{errors.message}</div>}
                </div>
                <div className="form-group center">
                    {/* <div className="button1 ms-3 w-fit justify-self-center mb-mob-80" onClick={handleSubmit}> */}
                    <div className="button1 text-align-center ms-3 w-247 justify-self-center mb-mob-80" onClick={handleSubmit}>
                        {
                            loader?<>
                            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                            <span className='ml-8'>Loading...</span>
                            </>:
                            'Send your message'
                        }
                    </div>
                </div>
            </form>

            <div className='d-flex gap-4px pptext center'>By clicking, you agree to our <a style={{color: '#78726D'}} href='#'>Terms & Conditions</a></div>
            <div className='pptext center'><a style={{color: '#78726D'}} href='#'>Privacy and Data Protection Policy</a></div>



            <Snackbar open={open.open} autoHideDuration={2000} 
            onClose={handleClose}
            >
            <Alert
                // onClose={handleClose}
                severity={open.msg==='Email sent successfully'?"success":"error"}
                variant="filled"
                sx={{ width: '100%' }}
            >
                {open.msg}
            </Alert>
            </Snackbar>
        </div>
    );
}

export default ContactForm;
